module.exports = {"TXTWCL_Login_to_bet":{"id":"TXTWCL_Login_to_bet","defaultMessage":"Autentifică-te pentru a paria","track":"Login to Bet"}}